import Image from "next/image";
const styles = new Proxy({"Award":"Award-79ae1"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

interface AwardProps {
  image: { url: string; width: number; height: number };
  title: string;
  link?: string;
  maxWidth?: number;
}

export default function Award({ image, title, link, maxWidth }: AwardProps) {
  const src = image.url;
  const width = typeof image === "string" ? undefined : image.width;
  const height = typeof image === "string" ? undefined : image.height;

  if (link) {
    return (
      <div className={`px-2 ${styles.Award}`}>
        <div>
          <Image
            src={src}
            alt={title}
            width={width}
            height={height}
            sizes="170px"
            style={{ maxWidth }}
          />
        </div>
        <a href={link} target="_blank">
          <p>{title}</p>
        </a>
      </div>
    );
  }

  return (
    <div className={`px-2 ${styles.Award}`}>
      <div>
        <Image
          src={src}
          alt={title}
          style={{ maxWidth }}
          width={width}
          height={height}
          sizes="170px"
        />
      </div>

      <p>{title}</p>
    </div>
  );
}
